module.exports = __webpack_public_path__ + "static/media/rank-3.9356f7ac.png";